function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer>
            <span className="footer-name">andriaberi</span>
            <span className="footer-copy">© {currentYear} Andria Beridze</span>
            <div className="footer-links">
                <a href="https://github.com/andriaberi" target="_blank" rel="noreferrer">GitHub</a>
                <a href="https://linkedin.com/in/andriaberidze" target="_blank" rel="noreferrer">LinkedIn</a>
                <a href="#root" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>Back to top ↑</a>
            </div>
        </footer>
    )
}

export default Footer;